import { AbstractCommand } from 'src/models/command';

class DeleteAppointmentWithMembersCommand extends AbstractCommand {
	readonly name = 'IFS_Calendar_Command_Commands_DeleteAppointmentWithMembers';
	readonly processId = 'random';

	public constructor(appointmentId: number) {
		super();

		this.parameters = {
			appointmentId: appointmentId,
		};
	}
}

export { DeleteAppointmentWithMembersCommand };
